import React from "react";

// Minimal chrome for a page opened via window.open() (see WorkspaceHub's
// popOutRunbookWindow) — no header, no sidebar, none of the normal app navigation. A
// popped-out window is meant to be read/acted on and closed, the same way a payment
// provider's popup shows just the payment form rather than the merchant's full site around
// it. Dark mode still applies — it's driven by `[data-theme]` on the document root, which
// this page shares with the rest of the app (see darkmode.css's `body` rule).
function PopupPage({ children }) {
  return <div className="py-3 px-4">{children}</div>;
}

export default PopupPage;
